"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInnerText = exports.getLangText = exports.fixNum = exports.numToLetter = exports.isPc = void 0;
const PAGE_TYPE = {
    H5: 1,
    PC: 10
};
const QA_LANG_KEY_PRE = {
    0: '',
    1: 'tc_',
    2: 'en_',
    5: 'ja_',
};
;
function isPc() {
    let route = null;
    if (window.FEGORender) {
        const { store } = window.FEGORender;
        route = store.route;
    }
    else {
        const { app: { project } } = window.FEGOEditor;
        route = project.route;
    }
    return (route === null || route === void 0 ? void 0 : route.now.pageType) === PAGE_TYPE.PC;
}
exports.isPc = isPc;
;
function numToLetter(num) {
    num = Number(num);
    if (isNaN(num) || num < 0 || num > 25) {
        return num;
    }
    return String.fromCharCode(num + 'A'.charCodeAt(0));
}
exports.numToLetter = numToLetter;
;
function fixNum(num) {
    return num < 10 ? `0${num}` : num;
}
exports.fixNum = fixNum;
;
function getLangText(obj, key, lang) {
    return obj[`${QA_LANG_KEY_PRE[lang]}${key}`] || '';
}
exports.getLangText = getLangText;
;
function getInnerText(html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText;
}
exports.getInnerText = getInnerText;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxNQUFNLFNBQVMsR0FBRztJQUNkLEVBQUUsRUFBRSxDQUFDO0lBQ0wsRUFBRSxFQUFFLEVBQUU7Q0FDVCxDQUFDO0FBRUYsTUFBTSxlQUFlLEdBQUc7SUFDcEIsQ0FBQyxFQUFFLEVBQUU7SUFDTCxDQUFDLEVBQUUsS0FBSztJQUNSLENBQUMsRUFBRSxLQUFLO0lBQ1IsQ0FBQyxFQUFFLEtBQUs7Q0FDWCxDQUFDO0FBUUQsQ0FBQztBQUVGLFNBQWdCLElBQUk7SUFDaEIsSUFBSSxLQUFLLEdBQU8sSUFBSSxDQUFDO0lBQ3JCLElBQUksTUFBTSxDQUFDLFVBQVUsRUFBRTtRQUNuQixNQUFNLEVBQUUsS0FBSyxFQUFFLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQztRQUNwQyxLQUFLLEdBQUcsS0FBSyxDQUFDLEtBQUssQ0FBQztLQUN2QjtTQUFNO1FBQ0gsTUFBTSxFQUNGLEdBQUcsRUFBRSxFQUFFLE9BQU8sRUFBRSxFQUNuQixHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUM7UUFDdEIsS0FBSyxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUM7S0FDekI7SUFDRCxPQUFPLENBQUEsS0FBSyxhQUFMLEtBQUssdUJBQUwsS0FBSyxDQUFFLEdBQUcsQ0FBQyxRQUFRLE1BQUssU0FBUyxDQUFDLEVBQUUsQ0FBQztBQUNoRCxDQUFDO0FBWkQsb0JBWUM7QUFBQSxDQUFDO0FBRUYsU0FBZ0IsV0FBVyxDQUFDLEdBQUc7SUFDM0IsR0FBRyxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUNsQixJQUFJLEtBQUssQ0FBQyxHQUFHLENBQUMsSUFBSSxHQUFHLEdBQUcsQ0FBQyxJQUFJLEdBQUcsR0FBRyxFQUFFLEVBQUc7UUFDcEMsT0FBTyxHQUFHLENBQUM7S0FDZDtJQUNELE9BQU8sTUFBTSxDQUFDLFlBQVksQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0FBQ3hELENBQUM7QUFORCxrQ0FNQztBQUFBLENBQUM7QUFFRixTQUFnQixNQUFNLENBQUUsR0FBRztJQUN2QixPQUFPLEdBQUcsR0FBRyxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksR0FBRyxFQUFFLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQztBQUN0QyxDQUFDO0FBRkQsd0JBRUM7QUFBQSxDQUFDO0FBRUYsU0FBZ0IsV0FBVyxDQUFDLEdBQUcsRUFBRSxHQUFHLEVBQUUsSUFBSTtJQUN0QyxPQUFPLEdBQUcsQ0FBQyxHQUFHLGVBQWUsQ0FBQyxJQUFJLENBQUMsR0FBRyxHQUFHLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUN2RCxDQUFDO0FBRkQsa0NBRUM7QUFBQSxDQUFDO0FBRUYsU0FBZ0IsWUFBWSxDQUFDLElBQUk7SUFDN0IsTUFBTSxHQUFHLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUMxQyxHQUFHLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQztJQUNyQixPQUFPLEdBQUcsQ0FBQyxTQUFTLENBQUM7QUFDekIsQ0FBQztBQUpELG9DQUlDO0FBQUEsQ0FBQyJ9